"use client";

import React, { useState } from "react";
import { ArrowRight, Award, CircleCheck as CheckCircle2, CircleQuestionMark as HelpCircle, Sparkles, Trophy, Cpu, Target, Compass, ArrowUpRight, ShieldAlert, Flame } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
interface DecisionRule {
  conditionVi: string;
  conditionEn: string;
  courseCode: string;
  courseNameVi: string;
  courseNameEn: string;
  noteVi: string;
  noteEn: string;
  tag: "Duplo" | "WhalesBot" | "Competition";
}
const DECISION_RULES: DecisionRule[] = [{
  conditionVi: "Trẻ 4–5 tuổi mới bắt đầu",
  conditionEn: "Child aged 4–5, beginning journey",
  courseCode: "D1",
  courseNameVi: "Bé làm kỹ sư",
  courseNameEn: "Junior Engineer",
  noteVi: "Làm quen chi tiết lắp ráp, kết cấu vững & tư duy thuật toán không dùng máy tính.",
  noteEn: "Foundation mechanics, structural stability & unplugged algorithmic thinking.",
  tag: "Duplo"
}, {
  conditionVi: "Trẻ 5 tuổi và đã hoàn thành D1",
  conditionEn: "Child aged 5, finished D1",
  courseCode: "D2",
  courseNameVi: "Thành phố của em",
  courseNameEn: "My City",
  noteVi: "Bánh răng, đòn bẩy, cơ cấu nâng hạ và chuỗi lệnh 4–6 bước.",
  noteEn: "Gears, levers, lifting mechanisms and 4–6 step command sequences.",
  tag: "Duplo"
}, {
  conditionVi: "Trẻ 5–6 tuổi (tùy lộ trình / sự sẵn sàng)",
  conditionEn: "Child aged 5–6 (depending on readiness)",
  courseCode: "D3",
  courseNameVi: "Cỗ máy kỳ diệu",
  courseNameEn: "Wondrous Machines",
  noteVi: "Tay quay, thanh truyền, tay gắp, flowchart bằng hình và debugging có hệ thống.",
  noteEn: "Cranks, linkages, grippers, visual flowcharts, and systematic debugging.",
  tag: "Duplo"
}, {
  conditionVi: "Trẻ 5–6 tuổi và sẵn sàng bước cầu nối",
  conditionEn: "Child aged 5–6, ready for the bridge",
  courseCode: "D4",
  courseNameVi: "Động cơ nhí",
  courseNameEn: "Little Motors",
  noteVi: "Pin, công tắc, động cơ điện, cơ chế Input → Process → Output trước khi sang WhalesBot.",
  noteEn: "Battery, motor, switch, Input → Process → Output before transitioning to WhalesBot.",
  tag: "Duplo"
}, {
  conditionVi: "Trẻ từ 7+ tuổi (sau D4 hoặc qua bài kiểm tra đầu vào)",
  conditionEn: "Child 7+ (after D4 or entrance assessment)",
  courseCode: "HP1",
  courseNameVi: "Kỹ sư cơ khí nhí",
  courseNameEn: "Junior Mechanical Engineer",
  noteVi: "Bắt đầu lập trình robot thực sự với bộ điều khiển WhalesBot AI Module 1S & Block Studio.",
  noteEn: "true programmable robotics with WhalesBot AI Module 1S controller & Block Studio.",
  tag: "WhalesBot"
}, {
  conditionVi: "Đã hoàn thành HP1",
  conditionEn: "Completed HP1",
  courseCode: "HP2",
  courseNameVi: "Robot biết cảm nhận",
  courseNameEn: "Sensory Robots",
  noteVi: "Cảm biến hồng ngoại, cảm biến chạm, điều kiện if-else, biến số và bánh răng côn.",
  noteEn: "Infrared & touch sensors, conditional branching, variables, and bevel gears.",
  tag: "WhalesBot"
}, {
  conditionVi: "Đã hoàn thành HP2",
  conditionEn: "Completed HP2",
  courseCode: "HP3",
  courseNameVi: "Xe robot đầu tiên",
  courseNameEn: "My First Robot Car",
  noteVi: "Khung gầm chuẩn, chuyển động chuẩn xác, chu vi bánh xe, góc quay & My Blocks.",
  noteEn: "Standard mobile chassis, precise steering, wheel circumference & My Blocks.",
  tag: "WhalesBot"
}, {
  conditionVi: "Đã hoàn thành HP3",
  conditionEn: "Completed HP3",
  courseCode: "HP4",
  courseNameVi: "Xe robot thông minh",
  courseNameEn: "Smart Mobile Robot",
  noteVi: "Phản hồi chướng ngại vật, chống rơi, đếm vạch, cơ cấu đẩy thụ động & logic đa cảm biến.",
  noteEn: "Obstacle avoidance, anti-fall, line counting, passive pushing & multi-sensor logic.",
  tag: "WhalesBot"
}, {
  conditionVi: "Đã hoàn thành HP4",
  conditionEn: "Completed HP4",
  courseCode: "HP5",
  courseNameVi: "Thành phố xe tự lái",
  courseNameEn: "Autonomous City Car",
  noteVi: "Cảm biến 5 kênh quang học, dò đường tuần tra, ngã tư, tính toán sai số & tìm đường ngắn nhất.",
  noteEn: "5-channel grayscale sensor, patrol line following, intersections, error correction & shortest path.",
  tag: "WhalesBot"
}, {
  conditionVi: "Đã hoàn thành HP5",
  conditionEn: "Completed HP5",
  courseCode: "HP6",
  courseNameVi: "Robot nhiệm vụ",
  courseNameEn: "Mission Robot",
  noteVi: "Cơ cấu nhiệm vụ đa năng, biến trạng thái, bài thi thử thách mô phỏng 150 giây.",
  noteEn: "Multi-function mission rigs, state variables, 150-second simulated tournament missions.",
  tag: "WhalesBot"
}, {
  conditionVi: "Đã hoàn thành HP6",
  conditionEn: "Completed HP6",
  courseCode: "ENJOY AI",
  courseNameVi: "Khóa luyện thi ENJOY AI",
  courseNameEn: "ENJOY AI Preparation",
  noteVi: "Lộ trình luyện thi tách biệt: luật thi đấu, sân sa bàn, tối ưu hóa chiến lược & nhiệm vụ bí mật.",
  noteEn: "Separate specialized preparation: competition arena, mission rules, strategy tuning & secret missions.",
  tag: "Competition"
}];
export default function EnjoyAiPathway() {
  const [lang, setLang] = useState<"vi" | "en">("vi");
  return <section id="enjoyaipathway" data-nav="light" className="relative bg-background text-foreground py-16 sm:py-24 border-t border-border overflow-hidden">
      {/* Subtle architectural background grid */}
      <div className="absolute inset-0 pointer-events-none opacity-40 bg-[linear-gradient(to_right,var(--border)_1px,transparent_1px),linear-gradient(to_bottom,var(--border)_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_0%,#000_70%,transparent_100%)]" aria-hidden="true" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-20">
        {/* Language switch header strip */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 pb-6 border-b border-border/80">
          <div>
            <Badge variant="outline" className="border-border text-muted-foreground uppercase tracking-wider text-xs">
              {lang === "vi" ? "Chương Trình Chuyên Sâu" : "Advanced Curriculum"}
            </Badge>
          </div>

          <div className="flex items-center gap-1.5 p-1 bg-muted rounded-lg border border-border">
            <Button size="sm" variant={lang === "vi" ? "default" : "ghost"} className="text-xs h-7 px-3 font-medium transition-colors" onClick={() => setLang("vi")}>
              Tiếng Việt
            </Button>
            <Button size="sm" variant={lang === "en" ? "default" : "ghost"} className="text-xs h-7 px-3 font-medium transition-colors" onClick={() => setLang("en")}>
              English
            </Button>
          </div>
        </div>

        {/* ========================================================================= */}
        {/* PART A: SAU HP6 — SẴN SÀNG CHO GIAI ĐOẠN LUYỆN THI */}
        {/* ========================================================================= */}
        <div className="space-y-8">
          <div className="max-w-3xl space-y-3">
            <div className="inline-flex items-center gap-2 text-primary font-semibold text-xs tracking-wider uppercase">
              <Trophy className="size-4 text-primary" />
              <span>{lang === "vi" ? "Giai Đoạn Nâng Cao & Đấu Trường" : "Advanced Phase & Arena Readiness"}</span>
            </div>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-foreground font-serif">
              {lang === "vi" ? "SAU HP6 — SẴN SÀNG CHO GIAI ĐOẠN LUYỆN THI" : "AFTER HP6 — READY FOR COMPETITION PREPARATION"}
            </h2>
            <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
              {lang === "vi" ? "HP6 đã trang bị đầy đủ mô hình thi đấu Invention Trials và nhiệm vụ tự hành 150 giây. Sau khi hoàn tất HP6, học sinh có nền tảng vững chắc để tham gia lộ trình chuẩn bị chuyên sâu cho giải đấu quốc tế ENJOY AI." : "HP6 already equips students with simulated Invention Trials missions and 150-second autonomous runs. Upon completion of HP6, students hold the exact engineering core required to transition into specialized ENJOY AI tournament training."}
            </p>
          </div>

          {/* Visual Progression Banner: HP6 -> ENJOY AI */}
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-stretch">
            {/* Step 1: HP6 Core Foundation */}
            <Card className="lg:col-span-5 bg-card border-border/80 shadow-xs relative overflow-hidden flex flex-col justify-between">
              <div className="absolute top-0 left-0 h-1 w-full bg-secondary" />
              <CardHeader className="space-y-2 pb-4">
                <div className="flex items-center justify-between">
                  <Badge variant="secondary" className="font-semibold text-xs">
                    HP6
                  </Badge>
                  <span className="text-xs text-muted-foreground font-mono">WhalesBot AI Module 1S</span>
                </div>
                <CardTitle className="text-xl font-bold text-foreground">
                  {lang === "vi" ? "Robot nhiệm vụ" : "Mission Robot"}
                </CardTitle>
                <CardDescription className="text-sm">
                  {lang === "vi" ? "Mô hình nhiệm vụ khép kín & thử thách 150 giây tự hành" : "Closed-loop mission mechanisms & 150-second autonomous challenge"}
                </CardDescription>
              </CardHeader>
              <CardContent className="space-y-4 pt-0 text-sm">
                <ul className="space-y-2.5 text-muted-foreground">
                  <li className="flex items-start gap-2">
                    <CheckCircle2 className="size-4 text-secondary shrink-0 mt-0.5" />
                    <span>
                      {lang === "vi" ? "Động cơ kết hợp cơ cấu thụ động (đẩy, nâng, nhả, phóng)." : "One-motor plus passive mechanisms (pushing, lifting, dropping, launching)."}
                    </span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle2 className="size-4 text-secondary shrink-0 mt-0.5" />
                    <span>
                      {lang === "vi" ? "Biến trạng thái kiểm soát quy trình và hàm tác vụ chuyên sâu." : "State variables controlling sequencing and dedicated task functions."}
                    </span>
                  </li>
                  <li className="flex items-start gap-2">
                    <CheckCircle2 className="size-4 text-secondary shrink-0 mt-0.5" />
                    <span>
                      {lang === "vi" ? "Làm quen thể thức thi đấu mô phỏng và chiến thuật làm bài." : "Hands-on experience with simulated tournament rules and reliability."}
                    </span>
                  </li>
                </ul>
                <div className="pt-2 border-t border-border/60">
                  <span className="text-xs font-medium text-foreground">
                    {lang === "vi" ? "Vị trí trong lộ trình: Đỉnh cao chương trình cốt lõi" : "Milestone: Peak of Core Robotics Pathway"}
                  </span>
                </div>
              </CardContent>
            </Card>

            {/* Transition Center Piece */}
            <div className="lg:col-span-2 flex flex-col items-center justify-center py-4 lg:py-0">
              <div className="flex lg:flex-col items-center gap-3">
                <div className="hidden lg:block w-px h-10 bg-border" />
                <div className="size-12 rounded-full bg-primary/10 border border-primary/20 flex items-center justify-center text-primary shadow-xs">
                  <ArrowRight className="size-5 hidden lg:block" />
                  <ArrowRight className="size-5 lg:hidden" />
                </div>
                <span className="text-xs font-semibold text-muted-foreground uppercase tracking-widest text-center px-2">
                  {lang === "vi" ? "Chuyển tiếp" : "Transition"}
                </span>
                <div className="hidden lg:block w-px h-10 bg-border" />
              </div>
            </div>

            {/* Step 2: Dedicated ENJOY AI Preparation */}
            <Card className="lg:col-span-5 bg-card border-primary/30 shadow-md relative overflow-hidden flex flex-col justify-between">
              <div className="absolute top-0 left-0 h-1 w-full bg-primary z-10" />

              {/* Competition Preparation Activity Photograph */}
              <div className="relative h-48 sm:h-52 w-full overflow-hidden bg-muted">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robot_competition_mat_testing.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robot_competition_mat_testing.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/robot_competition_mat_testing.png-wvc-sizes" alt="Robotics student calibrating sensors on an autonomous robot over a competition grid mat" className="w-full h-full object-cover object-center" loading="lazy" decoding="async" />
                <div className="absolute inset-0 bg-gradient-to-t from-card via-card/20 to-transparent pointer-events-none" />
              </div>

              <CardHeader className="space-y-2 pb-4">
                <div className="flex items-center justify-between">
                  <Badge variant="default" className="bg-primary text-primary-foreground font-semibold text-xs">
                    ENJOY AI
                  </Badge>
                  <span className="text-xs font-semibold text-primary flex items-center gap-1">
                    <Flame className="size-3" />
                    {lang === "vi" ? "Khóa luyện thi riêng biệt" : "Separate Preparation Track"}
                  </span>
                </div>
                <CardTitle className="text-xl font-bold text-foreground">
                  {lang === "vi" ? "KHÓA LUYỆN THI ENJOY AI" : "ENJOY AI PREPARATION COURSE"}
                </CardTitle>
                <CardDescription className="text-sm">
                  {lang === "vi" ? "Tối ưu hóa chiến thuật, sa bàn thi đấu & xử lý nhiệm vụ đặc thù" : "Tactical optimization, official arena setup & custom tournament missions"}
                </CardDescription>
              </CardHeader>
              <CardContent className="space-y-4 pt-0 text-sm">
                <ul className="space-y-2.5 text-muted-foreground">
                  <li className="flex items-start gap-2">
                    <Sparkles className="size-4 text-primary shrink-0 mt-0.5" />
                    <span>
                      {lang === "vi" ? "Huấn luyện chuyên sâu về luật thi đấu chính thức từng mùa giải." : "Intensive training on official tournament rulebooks for the active season."}
                    </span>
                  </li>
                  <li className="flex items-start gap-2">
                    <Sparkles className="size-4 text-primary shrink-0 mt-0.5" />
                    <span>
                      {lang === "vi" ? "Thực hành trực tiếp trên sa bàn kích thước chuẩn & tối ưu hóa tuyến đường." : "Direct practice on official competition mats & advanced path optimization."}
                    </span>
                  </li>
                  <li className="flex items-start gap-2">
                    <Sparkles className="size-4 text-primary shrink-0 mt-0.5" />
                    <span>
                      {lang === "vi" ? "Chiến lược xử lý 'Nhiệm vụ bí mật' (Secret Missions) công bố tại sân đấu." : "Strategies and rapid reprogramming for on-site unannounced Secret Missions."}
                    </span>
                  </li>
                </ul>

                {/* Explicit Curriculum Boundary Notice */}
                <div className="p-3 bg-muted/60 rounded-md border border-border/80 flex items-start gap-2.5 text-xs text-muted-foreground">
                  <ShieldAlert className="size-4 text-muted-foreground shrink-0 mt-0.5" />
                  <p className="leading-relaxed">
                    {lang === "vi" ? "Lưu ý minh bạch: ENJOY AI là lộ trình luyện thi độc lập, không phải HP7. Hoàn thành HP6 trang bị nền tảng kỹ thuật vững chắc nhưng không đồng nghĩa với cam kết giải thưởng hoặc suất tham dự tự động." : "Transparent guidance: ENJOY AI is an independent preparation pathway, not HP7. Completing HP6 delivers deep technical readiness but does not imply automatic qualification or guaranteed competition victory."}
                  </p>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>

        {/* ========================================================================= */}
        {/* PART B: PARENT DECISION GUIDE ('Con tôi nên bắt đầu từ đâu?') */}
        {/* ========================================================================= */}
        <div className="space-y-10 pt-8 border-t border-border">
          <div className="text-center max-w-3xl mx-auto space-y-3">
            <div className="inline-flex items-center justify-center gap-2 text-primary font-semibold text-xs tracking-wider uppercase">
              <Compass className="size-4 text-primary" />
              <span>{lang === "vi" ? "Định Hướng Nhập Học Cá Nhân Hóa" : "Personalized Enrollment Guide"}</span>
            </div>
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-foreground font-serif">
              {lang === "vi" ? "Con tôi nên bắt đầu từ đâu?" : "Where Should My Child Begin?"}
            </h2>
            <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
              {lang === "vi" ? "Lộ trình Robotics tại ROBOTO được xây dựng tuần tự dựa trên điều kiện tiên quyết và mức độ phát triển năng lực của trẻ, không chỉ đơn thuần xét theo độ tuổi." : "The ROBOTO Robotics curriculum is structured strictly on prerequisites and student developmental readiness, rather than chronological age alone."}
            </p>
          </div>

          {/* Decision Guide Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {DECISION_RULES.map((rule, idx) => {
            const isDuplo = rule.tag === "Duplo";
            const isWhalesBot = rule.tag === "WhalesBot";
            const isCompetition = rule.tag === "Competition";
            return <div key={rule.courseCode} data-index={idx} className="group relative bg-card rounded-xl border border-border/90 p-5 shadow-xs hover:shadow-md hover:border-primary/40 transition-all flex flex-col justify-between">
                  <div className="space-y-3">
                    {/* Header condition */}
                    <div className="flex items-center justify-between gap-2">
                      <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-muted-foreground">
                        <HelpCircle className="size-3.5 text-primary shrink-0" />
                        <span>{lang === "vi" ? "Trường hợp" : "Scenario"} {idx + 1}</span>
                      </span>

                      <Badge variant={isCompetition ? "default" : isDuplo ? "outline" : "secondary"} className={`text-2xs uppercase tracking-wider px-2 py-0.5 ${isCompetition ? "bg-primary text-primary-foreground" : ""}`}>
                        {rule.tag}
                      </Badge>
                    </div>

                    {/* Condition Statement */}
                    <div className="bg-muted/50 p-2.5 rounded-lg border border-border/60">
                      <p className="text-xs sm:text-sm font-semibold text-foreground leading-snug">
                        {lang === "vi" ? rule.conditionVi : rule.conditionEn}
                      </p>
                    </div>

                    {/* Arrow Pointer to Course */}
                    <div className="flex items-center gap-2 pt-1 text-primary">
                      <ArrowRight className="size-4 shrink-0" />
                      <div className="flex items-baseline gap-2">
                        <span className="font-mono font-bold text-base text-foreground tracking-tight">
                          {rule.courseCode}
                        </span>
                        <span className="text-xs font-medium text-foreground/80">
                          {lang === "vi" ? rule.courseNameVi : rule.courseNameEn}
                        </span>
                      </div>
                    </div>

                    {/* Explanatory Note */}
                    <p className="text-xs text-muted-foreground leading-relaxed pt-1">
                      {lang === "vi" ? rule.noteVi : rule.noteEn}
                    </p>
                  </div>

                  {/* Footer link / target */}
                  <div className="pt-4 mt-3 border-t border-border/60 flex items-center justify-between text-xs font-medium text-primary">
                    <span className="text-muted-foreground text-2xs">
                      {isDuplo ? "4–6 tuổi (Duplo)" : isWhalesBot ? "7+ tuổi (WhalesBot 1S)" : "Sau HP6 (Tournament)"}
                    </span>
                    <span className="inline-flex items-center gap-1 group-hover:translate-x-0.5 transition-transform">
                      {lang === "vi" ? "Chi tiết" : "View"}
                      <ArrowUpRight className="size-3" />
                    </span>
                  </div>
                </div>;
          })}
          </div>

          {/* Assessment & CTA Card */}
          <div className="bg-gradient-to-br from-card via-card to-muted/40 rounded-2xl border border-border p-6 sm:p-8 lg:p-10 shadow-sm relative overflow-hidden">
            <div className="max-w-3xl space-y-4">
              <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-secondary">
                <Target className="size-4" />
                <span>{lang === "vi" ? "Đánh Giá Đầu Vào Chính Xác" : "Accurate Placement Assessment"}</span>
              </div>
              <h3 className="text-xl sm:text-2xl lg:text-3xl font-bold tracking-tight text-foreground font-serif">
                {lang === "vi" ? "Chưa chắc chắn khóa học phù hợp nhất cho con?" : "Unsure which course is the right fit?"}
              </h3>
              <p className="text-muted-foreground text-sm sm:text-base leading-relaxed">
                {lang === "vi" ? "Học sinh từ 7 tuổi trở lên chưa từng học qua D1–D4 hoàn toàn có thể tham gia bài kiểm tra năng lực đầu vào miễn phí. Đội ngũ giáo viên chuyên môn của ROBOTO sẽ trực tiếp quan sát tư duy logic, kỹ năng thao tác và đề xuất cấp độ bắt đầu chuẩn xác nhất." : "Children aged 7+ without previous D1–D4 experience are welcome to take ROBOTO's complimentary entrance assessment. Our robotics instructors evaluate mechanical reasoning, algorithmic aptitude, and recommend the ideal starting tier."}
              </p>

              <div className="pt-2 flex flex-col sm:flex-row items-stretch sm:items-center gap-4">
                <Button asChild size="lg" className="font-semibold shadow-xs">
                  <Link to="/FreeTrialContactPage">
                    {lang === "vi" ? "Đăng ký kiểm tra & học thử miễn phí" : "Book Free Assessment & Trial"}
                    <ArrowRight className="size-4 ml-1" />
                  </Link>
                </Button>

                <Button asChild variant="outline" size="lg" className="font-semibold">
                  <Link to="/LearningPathCurriculumPage">
                    {lang === "vi" ? "Xem toàn bộ giáo trình D1–HP6" : "View Full D1–HP6 Curriculum"}
                  </Link>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}